import { t, translate } from "restaumatic-client";
import { observer } from "mobx-react";
import { h } from "preact";
import { useRef } from "preact/hooks";
import ItemCountBadge from "./ItemCountBadge";
const themeName = Skubacz.configuration.theme_name;
let badgeVariant;
switch (themeName) {
    case "minimax":
        badgeVariant = "default";
        break;
    case "behemot":
        badgeVariant = "secondary";
        break;
    case "sensei":
        badgeVariant = "primary-bg";
        break;
    default:
        badgeVariant = "primary-text";
}
function SectionItemButton(props) {
    const { menuSectionItemContent, openProductCreator, disableDropdown } = props;
    const handleClick = (variant, element) => {
        openProductCreator(variant.instance, element);
    };
    switch (menuSectionItemContent.type) {
        case "SingleProduct":
            if (menuSectionItemContent.dropdown === null) {
                return null;
            }
            return (h(ProductButton, { dropdown: menuSectionItemContent.dropdown, handleClick: handleClick, disableDropdown: disableDropdown }));
        case "Creator":
            return (h(CreatorButton, { "data-test": "creatorbutton", fieldId: "Menu.add." + menuSectionItemContent.variant.fieldId, onClick: (element) => handleClick(menuSectionItemContent.variant, element) }));
    }
}
const ProductButton = observer((props) => {
    const { dropdown, handleClick, disableDropdown } = props;
    switch (dropdown.type) {
        case "SingleDropdown":
            return h(VariantButton, { dropdown: dropdown, onClick: handleClick });
        case "VariantsDropdown":
            if (disableDropdown) {
                return h(VariantsButton, { dropdown: dropdown, onClick: handleClick });
            }
            return h(VariantsDropdown, { dropdown: dropdown, onClick: handleClick });
    }
});
const CreatorButton = observer((props) => {
    const { onClick, fieldId } = props;
    return (h("button", { onClick: (event) => onClick(event.currentTarget), type: "button", class: "btn add-button creator-button", "data-field-id": fieldId },
        h("span", { class: "icon-btn icon-shopping-cart", "aria-label": translate(t.theme_defaults.menu.add_to_cart) })));
});
// Button that behaves like a multiple variants dropdown, but is displayed as a single button
const VariantsButton = observer((props) => {
    const { dropdown, onClick } = props;
    const count = dropdown.items.reduce((acc, item) => acc + item.inCartQuantity, 0);
    return (h("div", { class: "btn-group" },
        h("button", { type: "button", class: "btn add-button", disabled: !dropdown.isAvailable, onClick: (event) => onClick(dropdown.items[0], event.currentTarget) },
            h("i", { class: "icon-btn icon-shopping-cart u-mr1", "aria-hidden": "true" }),
            " ",
            getPriceText(dropdown.price),
            " ",
            h(ItemCountBadge, { variant: badgeVariant, count: count }))));
});
const VariantsDropdown = observer((props) => {
    const { dropdown, onClick } = props;
    const buttonRef = useRef(null);
    const handleClick = (event, variant) => {
        var _a;
        event.preventDefault();
        if (variant.isAvailable) {
            onClick(variant, (_a = buttonRef.current) !== null && _a !== void 0 ? _a : undefined);
        }
    };
    return (h("div", { class: "btn-group" },
        h("button", { ref: buttonRef, type: "button", class: "btn add-button dropdown-toggle", "data-bs-toggle": "dropdown", "data-bs-display": "static", "aria-expanded": "false", disabled: !dropdown.isAvailable },
            h("i", { class: "icon-btn icon-shopping-cart u-mr1", "aria-hidden": "true" }),
            " ",
            getPriceText(dropdown.price),
            " ",
            h("span", { class: "caret" })),
        h("ul", { class: "dropdown-menu" }, dropdown.items.map((item) => (h("li", { key: item.fieldId },
            h("button", { type: "button", class: "u-btn-as-anchor-tag u-full-width u-text-left", onClick: (event) => handleClick(event, item), "data-field-id": "Menu.add." + item.fieldId },
                h(VariantTextWithBadge, { item: item, showChoiceName: true }))))))));
});
const VariantButton = observer((props) => {
    const { dropdown, onClick } = props;
    return (h("button", { onClick: (event) => onClick(dropdown.item, event.currentTarget), type: "button", class: "btn add-button", "data-field-id": "Menu.add." + dropdown.item.fieldId, disabled: !dropdown.item.isAvailable },
        h("i", { class: "icon-btn icon-shopping-cart u-mr1", "aria-hidden": "true" }),
        " ",
        h(VariantTextWithBadge, { item: dropdown.item, showChoiceName: false })));
});
const VariantTextWithBadge = observer(({ item, showChoiceName, }) => {
    return (h("span", null,
        getVariantText(item, showChoiceName),
        " ",
        h(ItemCountBadge, { variant: badgeVariant, count: item.inCartQuantity })));
});
function getVariantText(variant, showChoiceName) {
    const { price, variantParameterChoiceName } = variant;
    const label = [];
    if (showChoiceName && variantParameterChoiceName.length > 0) {
        label.push(variantParameterChoiceName);
    }
    const priceText = getPriceText(price);
    if (priceText !== null && priceText.length > 0) {
        label.push(priceText);
    }
    return label.join(" – ");
}
function getPriceText(price) {
    switch (price.type) {
        case "null":
            return translate(t.theme_defaults.menu.add_to_cart);
        case "value":
        case "range":
            return price.priceValue;
    }
}
export default observer(SectionItemButton);
